import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-basic-header',
  styleUrls: ['./basic-header.component.scss'],
  templateUrl: './basic-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
})
export class BasicHeaderComponent {
  @HostBinding('class.internal') @Input({ transform: booleanAttribute }) internal = false;
}
